/* istanbul ignore file */
import { Router, Route } from 'framework/routing';
import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import {
  ProcessInstanceShowPage,
  ProcessInstanceRedirect,
  IssuesTable,
  ProcessVariables,
} from 'domain/gpo/cockpit/instance/Show';
import { READ_INSTANCES_LIST } from 'domain/gpo/cockpit/instance/processInstanceService';
import { ProcessInstanceListPage } from 'domain/gpo/cockpit/instance/List';
import ProcessHistory from 'domain/gpo/cockpit/instance/Show/history/ProcessHistory';
import Subprocesses from 'domain/gpo/cockpit/instance/Show/subprocesses/Subprocesses';
import SupportIssuesTable from 'domain/gpo/cockpit/instance/Show/support/SupportIssuesTable';
import { MODIFY_INSTANCE_TOKEN_POSITIONS } from 'domain/gpo/cockpit/instance/Show/token/processInstanceTokenService';
import ModificationTokenPositions from 'domain/gpo/cockpit/instance/Show/token/ModificationTokenPositions';
import { RESOLVE_PROCESS_INCIDENT } from 'domain/gpo/cockpit/instance/Show/incident/processIncidentService';
import IncidentsTable from 'domain/gpo/cockpit/instance/Show/incident/IncidentsTable';
import ProcessEventFlowTracing from 'domain/gpo/cockpit/instance/Show/tracing/ProcessEventFlowTracing';
import { PROCESS_INSTANCE_PATH, useProcessInstanceRoute } from 'domain/gpo/cockpit/instance/processInstanceRoute';

const ProcessInstanceRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    historyRoute,
    issuesRoute,
    variablesRoute,
    subprocessesRoute,
    supportIssuesRoute,
    tokenModificationsRoute,
    incidentsRoute,
    tracingRoute,
  } = useProcessInstanceRoute();

  return (
    <ProtectedRouter basePath={PROCESS_INSTANCE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute path={singleEntityRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceRedirect />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={historyRoute}
          element={
            <GlobalProtectedRoute path={historyRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <ProcessHistory />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={issuesRoute}
          element={
            <GlobalProtectedRoute path={issuesRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <IssuesTable />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={variablesRoute}
          element={
            <GlobalProtectedRoute path={variablesRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <ProcessVariables />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={subprocessesRoute}
          element={
            <GlobalProtectedRoute path={subprocessesRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <Subprocesses />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={supportIssuesRoute}
          element={
            <GlobalProtectedRoute path={supportIssuesRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <SupportIssuesTable />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={tokenModificationsRoute}
          element={
            <GlobalProtectedRoute
              path={tokenModificationsRoute}
              globalPermissionToCheck={MODIFY_INSTANCE_TOKEN_POSITIONS}
            >
              <ProcessInstanceShowPage>
                <ModificationTokenPositions />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={incidentsRoute}
          element={
            <GlobalProtectedRoute path={incidentsRoute} globalPermissionToCheck={RESOLVE_PROCESS_INCIDENT}>
              <ProcessInstanceShowPage>
                <IncidentsTable />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={tracingRoute}
          element={
            <GlobalProtectedRoute path={tracingRoute} globalPermissionToCheck={READ_INSTANCES_LIST}>
              <ProcessInstanceShowPage>
                <ProcessEventFlowTracing />
              </ProcessInstanceShowPage>
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ProcessInstanceRouter.getRouterPath = () => `/instances/*`;

export default ProcessInstanceRouter;
